export default "__VITE_ASSET__Da48EjQj__"